import React, { FC, ReactNode } from 'react';
import { Paper, Typography } from '@mui/material';

interface KpiCardProps {
  label: ReactNode;
  value: ReactNode;
  sublabel?: ReactNode;
}

// Small metric tile (Paper + caption + h5 value + optional sublabel).
// Mirrors the KpiCard used in scenes/live-admin/Stats.tsx for marketing readability.
const KpiCard: FC<KpiCardProps> = ({ label, value, sublabel }) => (
  <Paper
    elevation={0}
    sx={{
      p: 2,
      flex: 1,
      backgroundColor: '#ffffff',
      border: '1px solid #e0e0e0',
      borderRadius: 1,
      minWidth: 120,
    }}
  >
    <Typography variant="caption" color="textSecondary">
      {label}
    </Typography>
    <Typography variant="h5" fontWeight={600} sx={{ mt: 0.5, lineHeight: 1.1 }}>
      {value}
    </Typography>
    {sublabel && (
      <Typography variant="caption" color="textSecondary">
        {sublabel}
      </Typography>
    )}
  </Paper>
);

export default KpiCard;
